import { styled } from '@mui/material'
import { InfoCard } from '../../infoCard'

const FacilityNoteCard = styled(InfoCard)({
    whiteSpace: 'pre-wrap',
})
export default FacilityNoteCard